"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.cancelable = void 0;
const axios_1 = __importDefault(require("axios"));
const { CancelToken } = axios_1.default;
exports.cancelable = async function cancelable(ctx, next) {
    if (!ctx.request.cancelToken && ctx.request.ref) {
        const source = CancelToken.source();
        ctx.request.cancelToken = source.token;
        ctx.request.ref.cancel = source.cancel;
    }
    try {
        await next();
    }
    finally {
        if (ctx.request.ref) {
            ctx.request.ref.cancel = null;
        }
    }
};
exports.cancelable.id = 'cancelable';
//# sourceMappingURL=cancelable.js.map